import EventsUpcomingContainer from './events_upcoming_container';

const EventsUpcoming = EventsUpcomingContainer;
export default EventsUpcoming;
